import { Component, Input } from '@angular/core';
import { CommercialAgreementInfo } from './commercial-agreement-status.types';

@Component({
  selector: 'unicon-commercial-agreement-status',
  templateUrl: './commercial-agreement-status.component.html',
})
export class CommercialAgreementStatusComponent {
  @Input() commercialAgreement: CommercialAgreementInfo | null = null;
}
